import { render, staticRenderFns } from "./catalog-filters-fitting.vue?vue&type=template&id=a74a7e24&scoped=true"
import script from "./catalog-filters-fitting.vue?vue&type=script&lang=js"
export * from "./catalog-filters-fitting.vue?vue&type=script&lang=js"
import style0 from "./catalog-filters-fitting.vue?vue&type=style&index=0&id=a74a7e24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74a7e24",
  null
  
)

export default component.exports